/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useLoanTapeTypesList = makeQueryHook(operations.loanTapeTypesList)

export const useLoanTapeTypeCreate = makeMutationHook(
  operations.loanTapeTypeCreate,
)

export const useLoanTapeTypeGet = makeQueryHook(operations.loanTapeTypeGet)

export const useLoanTapeTypeUpdate = makeMutationHook(
  operations.loanTapeTypeUpdate,
)

export const useLoanTapeTypeDelete = makeMutationHook(
  operations.loanTapeTypeDelete,
)

export const useLoanTapeTypeData = makeQueryHook(operations.loanTapeTypeData)

export const useLoanTapesList = makeQueryHook(operations.loanTapesList)

export const useLoanTapeCreate = makeMutationHook(operations.loanTapeCreate)

export const useLoanTapesGenerate = makeMutationHook(
  operations.loanTapesGenerate,
)

export const useLoanTapeGet = makeQueryHook(operations.loanTapeGet)

export const useLoanTapeUpdate = makeMutationHook(operations.loanTapeUpdate)

export const useLoanTapeDelete = makeMutationHook(operations.loanTapeDelete)

export const useGetAllLoansForLoanTape = makeQueryHook(
  operations.getAllLoansForLoanTape,
)

export const useLoanTapesDue = makeQueryHook(operations.loanTapesDue)

export const useLoanTapeRecordsList = makeQueryHook(
  operations.loanTapeRecordsList,
)

export const useLoanTapeRecordCreate = makeMutationHook(
  operations.loanTapeRecordCreate,
)

export const useLoanTapeRecordUpdate = makeMutationHook(
  operations.loanTapeRecordUpdate,
)
